import React, { useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import InputField, { InputDateField, TextareaField } from '../../../../utils/InputField';
import { handleAddSubscriptionsFeaturesOpe } from '../SubscriptionsDetailsOpe';

function AddSubscriptionsFeatureModal({ handleReload, appId, handleAddedNewFeature }) {
    const { setMessage } = useTemplate();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        ApplicationId: appId || '',
        FeatureName: '',
        FeatureDescription: '',
        DateDeployed: '',
        Status: 'active'
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleOnSubmit = (e) => {
        setLoading(true);
        e.preventDefault();
        handleAddSubscriptionsFeaturesOpe(formData)
            .then(({ title }) => {
                setLoading(false);
                setMessage({ type: 'success', text: title });
                handleAddedNewFeature();
                handleReload();
            })
            .catch((err) => {
                setLoading(false);
                setMessage({ type: 'error', text: err.toString(0) });
            });
    };
    return (
        <form onSubmit={handleOnSubmit} className="flex flex-col items-center justify-center gap-4">
            <InputField
                label="Feature Name"
                name="FeatureName"
                formData={formData}
                onChange={handleChange}
            />
            <TextareaField
                label="Feature Description"
                name="FeatureDescription"
                formData={formData}
                onChange={handleChange}
            />
            <InputDateField
                label="Deployment Data"
                name="DateDeployed"
                formData={formData}
                onChange={handleChange}
            />

            <div className="w-full flex flex-row gap-2 justify-end items-center">
                <ButtonCancel title="Cancel" onClick={handleAddedNewFeature} />
                <ButtonPrimary title="Save" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default AddSubscriptionsFeatureModal;
